import { Injectable } from "@angular/core";
import { Action, State, StateContext, StateToken } from "@ngxs/store";
import { AuthAction } from "./auth.actions";
import { Token } from "./auth.model";

const SETTINGS = new StateToken<Token>('Auth');

@State({
  name: SETTINGS,
  defaults: null
})

@Injectable()
export class AuthState 
{
  @Action(AuthAction)
  saveAuth(ctx: StateContext<Token>,action: AuthAction)
  {
    ctx.setState(action.authSettings);
  }

}
